// dropdown de filtro por día de la semana (envía dayId, muestra el nombre del día)
import React from 'react'
import { MenuItem, TextField } from '@mui/material'
import { ComponentProps } from '../../../../types/filters'
import { createFilterValueWithDisplay, parseFilterValueWithDisplay } from '../../../../types/filters'
import { WEEK_DAYS } from '../config'

export const WeekDayFilter: React.FC<ComponentProps> = ({
  value,
  onChange,
  fullWidth = true
}) => {
  const parsed = value ? parseFilterValueWithDisplay(value) : null
  const selectedDayId = parsed ? Number(parsed.id) : ''

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const dayId = Number(e.target.value)
    const day = WEEK_DAYS.find((d) => d.dayId === dayId)
    const eventValue = day ? createFilterValueWithDisplay(day.dayId, day.name) : ''
    onChange({ target: { value: eventValue, name: 'dayId' } } as React.ChangeEvent<HTMLInputElement>)
  }

  return (
    <TextField
      select
      variant='outlined'
      size='small'
      fullWidth={fullWidth}
      value={selectedDayId}
      onChange={handleChange}
      sx={{ height: '44px', '& .MuiInputBase-root': { height: '44px' } }}
    >
      <MenuItem value='' disabled>
        Seleccionar día...
      </MenuItem>
      {WEEK_DAYS.map((day) => (
        <MenuItem key={day.dayId} value={day.dayId}>
          {day.name}
        </MenuItem>
      ))}
    </TextField>
  )
}
